import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { NewUser } from '../models/newUser';

@Injectable()
export class UserService {
  constructor(private httpClient: HttpClient) {}

  baseurl = environment.apiBaseUrl;

  createUser(email): Observable<NewUser> {
    return this.httpClient.post<NewUser>(`${this.baseurl}/users`, { userName: email, email });
  }
}



// WEBPACK FOOTER //
// ./src/app/service/user.service.ts